
import React from 'react';


export const searchColumns = [
    {
        Header: <div style={{ textAlign: 'left' }} >Name</div>,
        accessor: 'name',
        Cell: row => <div className='ellipsisDiv' style={{ width: '350px', paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        // classNameGet: 'vtypefilter2',
        classNameGet: 'archivefilter1',

    },
    
]